var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage05Layer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 573",
    style: {
      enableBackground: "new 0 0 750 573"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}.st1{fill:#00cbd8}.st2{opacity:.5}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.9 3e2H723.7L735.4 315.8 724.3 332.1h7L742.5 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M717.7 3e2H710.5L722.2 315.8 711.1 332.1h7L729.3 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M704.5 3e2H697.3L709.1 315.8 698 332.1H704.9L716.1 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M691.3 3e2H684.2L695.9 315.8 684.8 332.1H691.7L703 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M678.2 3e2H671L682.7 315.8 671.6 332.1h7L689.8 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M665 3e2H657.8L669.5 315.8 658.4 332.1h7L676.6 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M651.8 3e2H644.6L656.4 315.8 645.2 332.1h7L663.4 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M638.6 3e2H631.5L643.2 315.8 632.1 332.1H639L650.2 315.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M625.5 3e2H618.3L630 315.8 618.9 332.1h7L637.1 315.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M605.8 409.3h-9.5v10h-10v9.5h10v10h9.5v-10h10v-9.5h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M605.8 485.6h-9.5v10h-10v9.5h10v10h9.5v-10h10v-9.5h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.1 419.3v-10h-9.5v10H650.5v9.5H660.6v10h9.5v-10h10v-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.1 485.6h-9.5v10H650.5v9.5H660.6v10h9.5v-10h10v-9.5h-10z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 294.1c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3.0-.5.0-.6.0-1.2.2-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5-.1.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7s-.2-1.2-.7-1.7C19.9 294.3 19.8 294.1 19.6 294.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 294.7 166.1 293.7 164.8 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 294.7 298 293.7 296.7 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 294.7 136.8 293.7 135.5 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 294.7 78.2 293.7 76.9 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 294.7 254 293.7 252.8 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 294.7 180.8 293.7 179.5 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 294.7 48.9 293.7 47.6 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 294.7 239.4 293.7 238.1 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 294.7 151.5 293.7 150.2 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 294.7 63.6 293.7 62.3 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 294.7 312.7 293.7 311.4 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 294.7 327.3 293.7 326 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 294.7 107.5 293.7 106.2 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 294.7 224.7 293.7 223.5 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 294.7 122.2 293.7 120.9 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 294.7 92.9 293.7 91.6 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 294.7 195.4 293.7 194.2 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 294.7 210.1 293.7 208.8 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 294.7 268.7 293.7 267.4 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 294.7 34.3 293.7 33 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 293.7c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 294.7 283.4 293.7 282.1 293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.3 294.3c-.4-.4-1-.7-1.7-.7-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.1-.1.3-.1.4-.1.3-.1.6.0.9.0.2.1.3.1.5.0.1.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.7.0-.3-.1-.6-.2-.9C342.7 294.8 342.5 294.5 342.3 294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 281c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.1.0-.3-.1-.5-.1-.6.0-1.2.3-1.7.7-.5.5-.8 1.3-.6 2.1.0.1.1.3.1.4.1.1.1.3.2.4.1.1.2.2.3.4.4.4 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.1.1.0.3-.1.4-.2.1-.1.2-.2.4-.3.1-.1.2-.2.3-.4.1-.1.2-.3.2-.4.1-.1.1-.3.1-.4.0-.2.0-.3.0-.5.0-.6-.2-1.2-.7-1.6C19.9 281.2 19.8 281.1 19.6 281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 281.6 254 280.6 252.8 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 281.6 107.5 280.6 106.2 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 281.6 239.4 280.6 238.1 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 281.6 63.6 280.6 62.3 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 281.6 298 280.6 296.7 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 281.6 283.4 280.6 282.1 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 281.6 268.7 280.6 267.4 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 281.6 92.9 280.6 91.6 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 281.6 78.2 280.6 76.9 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 281.6 136.8 280.6 135.5 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 281.6 122.2 280.6 120.9 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 281.6 151.5 280.6 150.2 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 281.6 312.7 280.6 311.4 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 281.6 224.7 280.6 223.5 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 281.6 210.1 280.6 208.8 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 281.6 180.8 280.6 179.5 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 281.6 327.3 280.6 326 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 281.6 48.9 280.6 47.6 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 281.6 34.3 280.6 33 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 281.6 166.1 280.6 164.8 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 280.6c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 281.6 195.4 280.6 194.2 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 280.6c-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.5.5-.8 1.3-.6 2.1.0.2.1.3.1.4.0.2.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.7C341.9 280.8 341.3 280.6 340.7 280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5 269c0-.1-.1-.3-.2-.4-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.6.0-1.2.2-1.6.7-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4-.1.2-.1.3-.1.5-.2.7.1 1.5.6 2.1.4.5 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.2.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7.0-.1.0-.3-.1-.4C20.6 269.3 20.5 269.1 20.5 269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 268.6 34.3 267.5 33 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 268.6 254 267.5 252.8 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 268.6 298 267.5 296.7 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 268.6 283.4 267.5 282.1 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 268.6 268.7 267.5 267.4 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 268.6 92.9 267.5 91.6 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 268.6 180.8 267.5 179.5 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 268.6 210.1 267.5 208.8 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 268.6 122.2 267.5 120.9 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 268.6 107.5 267.5 106.2 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 268.6 327.3 267.5 326 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 268.6 63.6 267.5 62.3 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 268.6 136.8 267.5 135.5 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 268.6 151.5 267.5 150.2 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 268.6 166.1 267.5 164.8 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 268.6 312.7 267.5 311.4 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 268.6 195.4 267.5 194.2 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 268.6 239.4 267.5 238.1 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 268.6 48.9 267.5 47.6 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 268.6 224.7 267.5 223.5 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 267.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 268.6 78.2 267.5 76.9 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 267.5c-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.5.5-.8 1.3-.6 2.1.0.2.1.3.1.5.0.1.1.3.2.4.1.1.2.3.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.7C341.9 267.8 341.3 267.5 340.7 267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 254.9c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3.0-.5.0-.6.0-1.2.2-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5-.1.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7s-.2-1.2-.7-1.7C19.9 255.1 19.8 255 19.6 254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S107.5 254.5 106.2 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1.1 2.3-2.3S224.7 254.5 223.5 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3C196.5 255.5 195.4 254.5 194.2 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S151.5 254.5 150.2 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1.1 2.3-2.3C123.2 255.5 122.2 254.5 120.9 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1.1 2.4-2.3C211.2 255.5 210.1 254.5 208.8 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S166.1 254.5 164.8 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S268.7 254.5 267.4 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1.1 2.3-2.3S254 254.5 252.8 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S136.8 254.5 135.5 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1.1 2.3-2.3S180.8 254.5 179.5 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S239.4 254.5 238.1 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1.1 2.3-2.3C79.3 255.5 78.2 254.5 76.9 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S34.3 254.5 33 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1.1 2.3-2.3S48.9 254.5 47.6 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3C93.9 255.5 92.9 254.5 91.6 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S327.3 254.5 326 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3C299.1 255.5 298 254.5 296.7 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S63.6 254.5 62.3 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3C284.4 255.5 283.4 254.5 282.1 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 254.5c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1.1 2.3-2.3S312.7 254.5 311.4 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 254.5c-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.1-.1.3-.1.4-.1.3-.1.6.0.9.0.1.1.3.1.4.0.1.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.2-.2.4-.5.5-.8.1-.3.2-.6.2-.9.0-.6-.2-1.2-.7-1.7C341.9 254.7 341.3 254.5 340.7 254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 241.8c-.1-.1-.3-.1-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.6.0-1.2.3-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7s-.2-1.2-.7-1.6C19.9 242 19.8 241.9 19.6 241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S166.1 241.4 164.8 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S136.8 241.4 135.5 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C299.1 242.5 298 241.4 296.7 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S327.3 241.4 326 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S254 241.4 252.8 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S63.6 241.4 62.3 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 241.4c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S224.7 241.4 223.5 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S239.4 241.4 238.1 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S151.5 241.4 150.2 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 241.4c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S48.9 241.4 47.6 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S312.7 241.4 311.4 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1.1 2.4-2.3C211.2 242.5 210.1 241.4 208.8 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S180.8 241.4 179.5 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S34.3 241.4 33 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S107.5 241.4 106.2 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S268.7 241.4 267.4 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C196.5 242.5 195.4 241.4 194.2 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C284.4 242.5 283.4 241.4 282.1 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1.1 2.3-2.3C79.3 242.5 78.2 241.4 76.9 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 241.4c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3C123.2 242.5 122.2 241.4 120.9 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 241.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C93.9 242.5 92.9 241.4 91.6 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.6 241.4c-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.2-.1.3-.1.5-.2.8.1 1.6.6 2.1.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.2-.2.4-.5.5-.8.1-.3.2-.6.2-.9.0-.6-.2-1.2-.7-1.7C341.9 241.7 341.3 241.4 340.6 241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5 229.8c0-.1-.1-.3-.2-.4-.1-.1-.2-.3-.3-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.4-.2-.1-.1-.3-.1-.4-.2-.2.0-.3.0-.5.0-.6.0-1.2.2-1.6.7-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4-.1.1-.1.3-.1.5-.2.7.1 1.5.6 2.1.4.5 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.2.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.6.0-.2.0-.3-.1-.4C20.6 230.1 20.5 230 20.5 229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 228.4c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C50 229.4 48.9 228.4 47.6 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C313.7 229.4 312.7 228.4 311.4 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C181.8 229.4 180.8 228.4 179.5 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C167.2 229.4 166.1 228.4 164.8 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C35.3 229.4 34.3 228.4 33 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C328.4 229.4 327.3 228.4 326 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1 2.4-2.3C211.2 229.4 210.1 228.4 208.8 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 228.4c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C225.8 229.4 224.7 228.4 223.5 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C152.5 229.4 151.5 228.4 150.2 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C196.5 229.4 195.4 228.4 194.2 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C108.6 229.4 107.5 228.4 106.2 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C240.5 229.4 239.4 228.4 238.1 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C299.1 229.4 298 228.4 296.7 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C64.6 229.4 63.6 228.4 62.3 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C269.8 229.4 268.7 228.4 267.4 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C255.1 229.4 254 228.4 252.8 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 228.4c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C123.2 229.4 122.2 228.4 120.9 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C79.3 229.4 78.2 228.4 76.9 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C284.4 229.4 283.4 228.4 282.1 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C93.9 229.4 92.9 228.4 91.6 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 228.4c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C137.9 229.4 136.8 228.4 135.5 228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 228.3c-.2.0-.3.0-.5.0-.2.0-.3.1-.4.1-.2.1-.3.1-.4.2-.1.1-.2.2-.3.3-.6.5-.8 1.3-.6 2.1.0.1.1.3.1.4.0.1.1.3.2.4.1.1.2.3.3.4.1.1.2.2.3.3.1.1.3.1.4.2.1.1.3.1.4.1.2.0.3.1.5.1.3.0.6-.1.9-.2.3-.1.5-.3.8-.5.2-.2.4-.5.5-.8.1-.3.2-.6.2-.9.0-.6-.2-1.2-.7-1.7C341.9 228.6 341.3 228.3 340.7 228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5 216.8c0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3.0-.5.0-.6.0-1.2.2-1.6.7-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4-.1.1-.1.3-.1.4-.2.8.1 1.6.6 2.1.4.4 1.1.7 1.7.7.2.0.3.0.5-.1.1.0.3-.1.4-.1.1.0.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.6.0-.2.0-.3-.1-.5C20.6 217 20.5 216.9 20.5 216.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S268.7 215.3 267.4 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C196.5 216.4 195.4 215.3 194.2 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S166.1 215.3 164.8 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C93.9 216.4 92.9 215.3 91.6 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C79.3 216.4 78.2 215.3 76.9 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1 2.4-2.3C211.2 216.4 210.1 215.3 208.8 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S254 215.3 252.8 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S180.8 215.3 179.5 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S107.5 215.3 106.2 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C284.4 216.4 283.4 215.3 282.1 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S151.5 215.3 150.2 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 215.3c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S224.7 215.3 223.5 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S63.6 215.3 62.3 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S136.8 215.3 135.5 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S239.4 215.3 238.1 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S312.7 215.3 311.4 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 215.3c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S48.9 215.3 47.6 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S34.3 215.3 33 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 215.3c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C123.2 216.4 122.2 215.3 120.9 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S327.3 215.3 326 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 215.3c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C299.1 216.4 298 215.3 296.7 215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.3 216c-.4-.4-1-.7-1.7-.7-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.0-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.1-.1.3-.1.4-.1.3-.1.6.0.9.0.1.1.3.1.4.0.1.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.1.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.2-.2.4-.5.5-.8.1-.3.2-.6.2-.9.0-.3-.1-.6-.2-.9C342.7 216.5 342.5 216.2 342.3 216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 202.6c-.1-.1-.3-.1-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.6C19.9 202.8 19.8 202.7 19.6 202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S136.8 202.2 135.5 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S166.1 202.2 164.8 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 202.2c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S48.9 202.2 47.6 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C93.9 203.3 92.9 202.2 91.6 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S34.3 202.2 33 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S151.5 202.2 150.2 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 202.2c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3C123.2 203.3 122.2 202.2 120.9 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S107.5 202.2 106.2 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S63.6 202.2 62.3 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S180.8 202.2 179.5 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1.1 2.3-2.3C79.3 203.3 78.2 202.2 76.9 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C284.4 203.3 283.4 202.2 282.1 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S312.7 202.2 311.4 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C299.1 203.3 298 202.2 296.7 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S254 202.2 252.8 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S268.7 202.2 267.4 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 202.2c-1.3.0-2.3 1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3S224.7 202.2 223.5 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S239.4 202.2 238.1 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1.1 2.4-2.3C211.2 203.3 210.1 202.2 208.8 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3S327.3 202.2 326 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 202.2c-1.3.0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1.1 2.3-2.3C196.5 203.3 195.4 202.2 194.2 202.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.3 202.9c-.4-.5-1-.7-1.7-.7-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.1-.1.3-.1.5-.1.3-.1.6.0.9.0.1.1.3.1.4s.1.3.2.4c.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.7.0-.3-.1-.6-.2-.9C342.7 203.4 342.5 203.1 342.3 202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 189.6c-.1-.1-.3-.1-.4-.2-.1-.1-.3-.1-.4-.2-.2.0-.3.0-.5.0-.6.0-1.2.2-1.7.7-.9.9-.9 2.5.0 3.3.4.5 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.2.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.6s-.2-1.2-.7-1.6C19.9 189.8 19.8 189.7 19.6 189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S34.3 189.2 33 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S254 189.2 252.8 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 189.2c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C123.2 190.2 122.2 189.2 120.9 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S239.4 189.2 238.1 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S107.5 189.2 106.2 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 189.2c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S224.7 189.2 223.5 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S136.8 189.2 135.5 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C93.9 190.2 92.9 189.2 91.6 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C299.1 190.2 298 189.2 296.7 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S63.6 189.2 62.3 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S151.5 189.2 150.2 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 189.2c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S48.9 189.2 47.6 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C79.3 190.2 78.2 189.2 76.9 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S268.7 189.2 267.4 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C284.4 190.2 283.4 189.2 282.1 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S312.7 189.2 311.4 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S327.3 189.2 326 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S180.8 189.2 179.5 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C196.5 190.2 195.4 189.2 194.2 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1 2.4-2.3C211.2 190.2 210.1 189.2 208.8 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 189.2c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S166.1 189.2 164.8 189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.3 189.9c-.4-.4-1-.7-1.7-.7-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.2-.1.3-.1.5-.1.3-.1.6.0.9.0.1.1.3.1.4.0.1.1.3.2.4.1.1.2.3.3.4.1.1.2.2.4.3.1.1.3.1.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.6.0-.3-.1-.6-.2-.9C342.7 190.3 342.5 190.1 342.3 189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 176.5c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.6.0-1.2.3-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5-.1.1.0.3-.1.4-.1.1.0.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.7C19.9 176.7 19.8 176.6 19.6 176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S107.5 176.1 106.2 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S327.3 176.1 326 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S136.8 176.1 135.5 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S239.4 176.1 238.1 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 176.1c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C123.2 177.2 122.2 176.1 120.9 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S166.1 176.1 164.8 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S254 176.1 252.8 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S180.8 176.1 179.5 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C299.1 177.2 298 176.1 296.7 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S63.6 176.1 62.3 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 176.1c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S48.9 176.1 47.6 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S312.7 176.1 311.4 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C79.3 177.2 78.2 176.1 76.9 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S268.7 176.1 267.4 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S34.3 176.1 33 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C93.9 177.2 92.9 176.1 91.6 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C284.4 177.2 283.4 176.1 282.1 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C196.5 177.2 195.4 176.1 194.2 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S151.5 176.1 150.2 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 176.1c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S224.7 176.1 223.5 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 176.1c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1 2.4-2.3C211.2 177.2 210.1 176.1 208.8 176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.3 176.8c-.4-.4-1-.7-1.7-.7-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.0-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.1-.1.3-.1.4-.1.7.1 1.6.6 2.1.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.4-.5.7-1 .7-1.6.0-.3-.1-.6-.2-.9C342.7 177.3 342.5 177 342.3 176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 163.5c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.6.0-1.2.2-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7s-.2-1.2-.7-1.6C19.9 163.7 19.8 163.5 19.6 163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 163c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C225.8 164.1 224.7 163 223.5 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C196.5 164.1 195.4 163 194.2 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C79.3 164.1 78.2 163 76.9 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C313.7 164.1 312.7 163 311.4 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C108.6 164.1 107.5 163 106.2 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C255.1 164.1 254 163 252.8 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C93.9 164.1 92.9 163 91.6 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C64.6 164.1 63.6 163 62.3 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C284.4 164.1 283.4 163 282.1 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C35.3 164.1 34.3 163 33 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C152.5 164.1 151.5 163 150.2 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C328.4 164.1 327.3 163 326 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C269.8 164.1 268.7 163 267.4 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C181.8 164.1 180.8 163 179.5 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1 2.4-2.3C211.2 164.1 210.1 163 208.8 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C137.9 164.1 136.8 163 135.5 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 163c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C123.2 164.1 122.2 163 120.9 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C167.2 164.1 166.1 163 164.8 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C299.1 164.1 298 163 296.7 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 163c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C240.5 164.1 239.4 163 238.1 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 163c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C50 164.1 48.9 163 47.6 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 163c-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.2-.1.3-.1.5-.2.8.1 1.5.6 2.1.1.1.2.2.4.3.1.1.3.1.4.2.1.1.3.1.4.1.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.7C341.9 163.3 341.3 163 340.7 163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 150.4c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3.0-.5.0-.6.0-1.2.2-1.7.7-.9.9-.9 2.5.0 3.3.4.4 1 .7 1.7.7.2.0.3.0.5-.1.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.6.0-.6-.2-1.2-.7-1.7C19.9 150.6 19.8 150.5 19.6 150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 151 268.7 150 267.4 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 151 224.7 150 223.5 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 151 78.2 150 76.9 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 151 166.1 150 164.8 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 151 151.5 150 150.2 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 151 283.4 150 282.1 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 151 34.3 150 33 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 151 298 150 296.7 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 151 210.1 150 208.8 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 151 92.9 150 91.6 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 151 136.8 150 135.5 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 151 48.9 150 47.6 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 151 312.7 150 311.4 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 151 180.8 150 179.5 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 151 254 150 252.8 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 151 122.2 150 120.9 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 151 63.6 150 62.3 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 151 239.4 150 238.1 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 151 107.5 150 106.2 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 151 327.3 150 326 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 150c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 151 195.4 150 194.2 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 150c-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.2-.1.3-.1.4-.1.3-.1.6.0.9.0.2.1.3.1.5.0.1.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.6.0-.6-.2-1.2-.7-1.7C341.9 150.2 341.3 150 340.7 150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 137.3c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.6.0-1.2.3-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1 .7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.1.1.0.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.6C19.9 137.5 19.8 137.4 19.6 137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S180.8 136.9 179.5 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C299.1 138 298 136.9 296.7 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C196.5 138 195.4 136.9 194.2 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3C79.3 138 78.2 136.9 76.9 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S63.6 136.9 62.3 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C284.4 138 283.4 136.9 282.1 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S268.7 136.9 267.4 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3S254 136.9 252.8 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 136.9c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S48.9 136.9 47.6 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S166.1 136.9 164.8 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S34.3 136.9 33 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S107.5 136.9 106.2 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 136.9c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3S224.7 136.9 223.5 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 136.9c-1.3.0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1 2.3-2.3C123.2 138 122.2 136.9 120.9 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S136.8 136.9 135.5 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S239.4 136.9 238.1 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.4-1 2.4-2.3C211.2 138 210.1 136.9 208.8 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S327.3 136.9 326 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3C93.9 138 92.9 136.9 91.6 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S151.5 136.9 150.2 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 136.9c-1.3.0-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.3.0 2.3-1 2.3-2.3S312.7 136.9 311.4 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 136.9c-.2.0-.3.0-.5.1-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4.0.1-.1.3-.1.4-.1.3-.1.6.0.9.0.1.1.3.1.4.0.1.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.7C341.9 137.2 341.3 136.9 340.7 136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 124.3c-.1-.1-.3-.1-.4-.2-.1-.1-.3-.1-.4-.2-.2.0-.3.0-.5.0-.6.0-1.2.2-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.2.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.6C19.9 124.5 19.8 124.4 19.6 124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 124.9 312.7 123.9 311.4 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 124.9 298 123.9 296.7 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 124.9 63.6 123.9 62.3 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 124.9 210.1 123.9 208.8 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 124.9 48.9 123.9 47.6 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 124.9 92.9 123.9 91.6 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 124.9 195.4 123.9 194.2 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 124.9 107.5 123.9 106.2 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 124.9 327.3 123.9 326 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 124.9 136.8 123.9 135.5 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 124.9 166.1 123.9 164.8 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 124.9 224.7 123.9 223.5 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 124.9 122.2 123.9 120.9 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 124.9 239.4 123.9 238.1 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 124.9 254 123.9 252.8 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 124.9 283.4 123.9 282.1 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 124.9 34.3 123.9 33 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 124.9 78.2 123.9 76.9 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 124.9 180.8 123.9 179.5 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 124.9 151.5 123.9 150.2 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 123.9c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 124.9 268.7 123.9 267.4 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 123.9c-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.1-.3.1-.4.2-.1.1-.2.2-.4.3-.5.5-.8 1.3-.6 2.1.0.1.1.3.1.4.0.1.1.3.2.4.1.1.2.3.3.4.1.1.2.2.4.3.1.1.3.1.4.2.1.1.3.1.4.2.2.0.3.0.5.0.6.0 1.2-.2 1.7-.7.4-.4.7-1 .7-1.6.0-.6-.2-1.2-.7-1.7C341.9 124.1 341.3 123.9 340.7 123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 111.2c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3.0-.5.0-.6.0-1.2.2-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1 .7 1.7.7.2.0.3.0.5-.1.1.0.3-.1.4-.1.1-.1.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7s-.2-1.2-.7-1.6C19.9 111.4 19.8 111.3 19.6 111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 111.9 180.8 110.8 179.5 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 111.9 327.3 110.8 326 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 111.9 312.7 110.8 311.4 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 111.9 34.3 110.8 33 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 111.9 283.4 110.8 282.1 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 111.9 239.4 110.8 238.1 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 111.9 107.5 110.8 106.2 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 111.9 166.1 110.8 164.8 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 111.9 254 110.8 252.8 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 111.9 195.4 110.8 194.2 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 111.9 92.9 110.8 91.6 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 111.9 122.2 110.8 120.9 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 111.9 151.5 110.8 150.2 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 111.9 48.9 110.8 47.6 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 111.9 136.8 110.8 135.5 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 111.9 224.7 110.8 223.5 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 111.9 268.7 110.8 267.4 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 111.9 210.1 110.8 208.8 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 111.9 78.2 110.8 76.9 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 111.9 63.6 110.8 62.3 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 110.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 111.9 298 110.8 296.7 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.7 110.8c-.2.0-.3.0-.5.0-.1.0-.3.1-.4.1-.1.0-.3.1-.4.2-.1.1-.2.2-.4.3-.5.5-.8 1.3-.6 2.1.0.2.1.3.1.5.0.1.1.3.2.4.1.1.2.2.3.4.1.1.2.2.4.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.1.5.1.6.0 1.2-.2 1.7-.7.2-.2.4-.5.5-.8.1-.3.2-.6.2-.9.0-.6-.2-1.2-.7-1.7C341.9 111.1 341.3 110.8 340.7 110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6 98.2c-.1-.1-.3-.2-.4-.2-.1-.1-.3-.1-.4-.1-.2.0-.3-.1-.5-.1-.6.0-1.2.3-1.7.7-.9.9-.9 2.4.0 3.3.4.4 1.1.7 1.7.7.2.0.3.0.5.0.1.0.3-.1.4-.1.1.0.3-.1.4-.2.1-.1.2-.2.4-.3.4-.4.7-1 .7-1.7.0-.6-.2-1.2-.7-1.6C19.9 98.3 19.8 98.2 19.6 98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.5 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C225.8 98.8 224.7 97.8 223.5 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.5 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C181.8 98.8 180.8 97.8 179.5 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.4 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C313.7 98.8 312.7 97.8 311.4 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.9 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C123.2 98.8 122.2 97.8 120.9 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1.1 2.3 2.3 2.3s2.3-1 2.3-2.3C50 98.8 48.9 97.8 47.6 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.4-1 2.4-2.3C211.2 98.8 210.1 97.8 208.8 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.7 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C299.1 98.8 298 97.8 296.7 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C269.8 98.8 268.7 97.8 267.4 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C152.5 98.8 151.5 97.8 150.2 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C137.9 98.8 136.8 97.8 135.5 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C35.3 98.8 34.3 97.8 33 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C255.1 98.8 254 97.8 252.8 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.8 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C167.2 98.8 166.1 97.8 164.8 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.2 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C196.5 98.8 195.4 97.8 194.2 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C93.9 98.8 92.9 97.8 91.6 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3C79.3 98.8 78.2 97.8 76.9 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C240.5 98.8 239.4 97.8 238.1 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C64.6 98.8 63.6 97.8 62.3 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C284.4 98.8 283.4 97.8 282.1 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C108.6 98.8 107.5 97.8 106.2 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326 97.8c-1.3.0-2.3 1-2.3 2.3.0 1.3 1 2.3 2.3 2.3 1.3.0 2.3-1 2.3-2.3C328.4 98.8 327.3 97.8 326 97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.5 101c0 .2.1.3.2.4.1.1.2.2.3.4.1.1.2.2.3.3.1.1.3.2.4.2.1.1.3.1.4.1.2.0.3.0.5.0.3.0.6-.1.9-.2.3-.1.5-.3.8-.5.2-.2.4-.5.5-.8.1-.3.2-.6.2-.9.0-.6-.2-1.2-.7-1.7-.4-.5-1-.7-1.7-.7-.2.0-.3.0-.5.1-.2.0-.3.1-.4.1-.2.1-.3.1-.4.2-.1.1-.2.2-.3.3-.1.1-.2.2-.3.4-.1.1-.2.3-.2.4-.1.1-.1.3-.1.5-.1.3-.1.6.0.9C338.4 100.7 338.5 100.9 338.5 101z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.8 468.9c2.6-1.4 10.9-7.7 10.9-28.3.0-5.7.7-11.3 2-16.8.5-2-.8-4-2.8-4.5-2-.5-4 .8-4.5 2.8-1.5 6-2.2 12.3-2.2 18.5.0 16.1-5.7 20.8-6.9 21.6-1.8.6-3.5 1.3-5.2 2.1.7 2.5 1.4 4.9 2.2 7.2 1.9-.9 3.8-1.7 5.8-2.4C107.4 469.1 107.6 469 107.8 468.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.2 450.6c.2-2.1-1.3-3.9-3.3-4.1-2.1-.2-3.9 1.3-4.1 3.3-3.5 32.3-24.6 40-25.4 40.3-1.9.6-3.7 1.3-5.3 2.2 1.4 2.1 2.9 4.1 4.5 6.1 1-.5 2.1-.9 3.2-1.2C120.8 496.9 146.2 487.6 150.2 450.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154 487.9c1.1-1.7.7-4-1.1-5.2-1.7-1.1-4.1-.7-5.2 1.1-10.4 15.8-24.2 20.4-24.8 20.6-.3.1-.7.2-1 .3 1.9 2 3.9 3.9 6 5.7C133.3 508.2 144.8 501.9 154 487.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9 483c3.5-1.4 20.8-10 20.8-42.4.0-24.8 15.9-46.4 39.5-53.7 2-.6 3.1-2.7 2.5-4.7-.6-2-2.7-3.1-4.7-2.5-26.8 8.3-44.8 32.8-44.8 60.9.0 27.7-13.9 34.6-16 35.5-2.4.8-4.6 1.7-6.8 2.9 1 2.3 2.2 4.5 3.4 6.7 1.9-1 3.8-1.8 5.9-2.5C113.8 483.1 113.8 483.1 113.9 483z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.1 476.6c1.9-5.6 3.4-11.7 4.3-18 .3-2-1.1-4-3.2-4.2-2-.3-4 1.1-4.2 3.2-.9 5.8-2.2 11.4-4 16.6-8.6 25.2-25.8 37-35.2 41.8 2.3 1.7 4.7 3.2 7.1 4.6C152.8 514.2 168.8 501 177.1 476.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.7 440.6c0-2.1-1.7-3.8-3.8-3.8s-3.8 1.7-3.8 3.8c0 31.2-9.6 56.2-28.5 74.3-4.1 4-8.3 7.2-12.1 9.7 2.7 1.3 5.4 2.4 8.2 3.4 2.8-2.1 5.8-4.6 8.8-7.4C180.8 507.1 197.7 482.3 197.7 440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.9 491c-1.9-.8-4.1.0-4.9 1.9-5.6 12.7-13.4 23.9-23.2 33.2-1.7 1.7-3.5 3.2-5.2 4.6 3 .8 6.1 1.4 9.3 1.8.4-.3.7-.7 1.1-1 10.5-10 18.9-22 24.9-35.6C202.6 494 201.8 491.8 199.9 491z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.1 416.4c1.9.8 4.1-.1 4.9-2 .8-1.9-.1-4.1-2-4.9-4.2-1.8-8.6-2.6-13.1-2.6-18.6.0-33.8 15.1-33.8 33.8.0 9.2-1.1 17.7-3.4 25.4-.6 2 .6 4.1 2.6 4.6.4.1.7.2 1.1.2 1.6.0 3.1-1.1 3.6-2.7 2.4-8.3 3.6-17.6 3.6-27.5.0-14.5 11.8-26.2 26.2-26.2C196.5 414.4 199.9 415 203.1 416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.1 478.5c.3.1.6.1.9.1 1.7.0 3.2-1.1 3.6-2.8 2.7-11 4.1-22.8 4.1-35.2.0-10.3-8.4-18.8-18.8-18.8-10.3.0-18.8 8.4-18.8 18.8.0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8c0-6.2 5-11.2 11.2-11.2 6.2.0 11.2 5 11.2 11.2.0 11.8-1.3 23-3.8 33.4C200.8 476 202.1 478 204.1 478.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.2 425.7c-.9-1.9-3.2-2.6-5-1.7-1.8.9-2.6 3.2-1.7 5 1.8 3.6 2.7 7.5 2.7 11.6.0 46.3-18 75.6-34.6 92.8 1.6.1 3.1.1 4.7.1 1.8.0 3.7.0 5.5-.2 16.1-18.7 31.9-48.4 31.9-92.8C226.7 435.4 225.5 430.3 223.2 425.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229 493.1c-1.9-.7-4.1.3-4.8 2.3-4.8 13.5-11.5 25.9-19.9 36.9 3.7-.6 7.4-1.4 11-2.5 6.6-9.8 11.9-20.5 16-31.9C232 496 231 493.8 229 493.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235 467.8c.2.0.3.0.5.0 1.9.0 3.5-1.4 3.7-3.3 1-7.7 1.5-15.8 1.5-24 0-26.9-21.9-48.8-48.8-48.8-23.3.0-43.5 16.6-47.9 39.5-.4 2 .9 4 3 4.4 2 .4 4-.9 4.4-3 3.7-19.4 20.8-33.5 40.5-33.5 22.7.0 41.2 18.5 41.2 41.2.0 7.9-.5 15.6-1.4 23C231.5 465.7 232.9 467.5 235 467.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.2 399c-9.9-11.5-23.5-19-38.4-21.3-2.1-.3-4 1.1-4.3 3.1-.3 2 1.1 4 3.1 4.3 27.1 4.2 47.6 28.1 47.6 55.6.0 36.6-9.5 64.7-21.8 85.7 4.1-1.7 8-3.7 11.7-5.9 10.2-20.7 17.6-47 17.6-79.8C254.7 425.3 249.2 410.5 239.2 399z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9 402.2c.7 1.1 1.9 1.7 3.2 1.7.7.0 1.4-.2 2-.6 1.7-1.1 2.2-3.4 1.1-5.2-14.6-22.7-39.4-36.3-66.3-36.3-25.5.0-49.5 12.5-64.3 33.3-1.2 1.7-.8 4 .9 5.2s4 .8 5.2-.9c13.4-18.9 35.1-30.2 58.2-30.2C214.3 369.4 236.7 381.6 249.9 402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.4 346.9c-.7.0-1.3.0-2 0h-.2C137.7 347 96 388.7 96 440.2c0 5.5.5 11 1.4 16.3.3-.1.6-.2.8-.3.8-.3 1.5-1 1.9-1.7 1.1-2.2 2.5-6.3 2.5-13.8.0-47.6 38.7-86.2 86.2-86.2s86.2 38.7 86.2 86.2c0 16.6-1.7 31.8-4.6 45.6 7.7-13.5 12.1-29.2 12.1-45.8v-.2C282.7 389.3 242 347.9 191.4 346.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.9 436.9c-2.1.0-3.8 1.7-3.8 3.8.0 28.8-5.4 52.7-13.5 72.5 4.4-3.5 8.5-7.5 12.2-11.7 5.5-17.5 8.9-37.6 8.9-60.8C268.7 438.5 267 436.9 264.9 436.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104 365.6l-5.5-4.8c-3 3.4-5.7 7-8.3 10.7l6 4.2C98.6 372.2 101.2 368.8 104 365.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.4 326.9v-7.4c-19.3.0-37.5 4.5-53.7 12.6l3.3 6.6C154.1 331.1 171.2 326.9 189.4 326.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.8 343.2l-3.8-6.3c-7.9 4.8-15.2 10.4-21.7 16.8l5.1 5.3C116.6 352.9 123.4 347.6 130.8 343.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.1 476.8l-7 2.4c1.5 4.3 3.2 8.5 5.1 12.5l6.6-3.1C85.1 484.8 83.5 480.8 82.1 476.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.2 383.5l-6.4-3.7c-9.1 15.7-14.7 33.7-15.9 52.8l7.3.5C77.3 416.2 82.2 399.2 91.2 383.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.1 442.4l-7.3.1c.2 9.4 1.4 18.5 3.6 27.2l7.1-1.8C77.4 459.6 76.2 451 76.1 442.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.4 551.4l-1.4 7.2c4.4.9 8.9 1.5 13.4 1.9l.6-7.3C175.8 552.8 171.6 552.2 167.4 551.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.2 496.8l-6.4 3.7c9.3 16.1 22.3 29.9 37.8 40.2l4.1-6.1C112.5 525.3 100.3 512.5 91.2 496.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.6 539.4l-3.6 6.4c8 4.4 16.5 7.9 25.4 10.5l2-7.1C150.2 546.9 142.2 543.6 134.6 539.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.9 537.2l3.8 6.3c7.9-4.8 15.2-10.4 21.7-16.8l-5.1-5.3C262.2 527.5 255.3 532.8 247.9 537.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.3 553.5v7.3c0 0 0 0 0 0 19.3.0 37.5-4.5 53.7-12.6l-3.3-6.6C224.6 549.3 207.5 553.5 189.3 553.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.7 514.8l5.5 4.8c3-3.4 5.7-7 8.3-10.7l-6-4.2C280.1 508.2 277.5 511.6 274.7 514.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.6 403.6l7-2.4c-1.5-4.3-3.2-8.5-5.1-12.6l-6.7 3.1C293.6 395.6 295.2 399.6 296.6 403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.2 412.5c2.1 8.3 3.3 16.9 3.4 25.5l7.4-.1c-.2-9.4-1.4-18.5-3.6-27.2L299.2 412.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.5 496.8l6.4 3.7c9.1-15.7 14.7-33.7 15.9-52.8l-7.3-.5C301.5 464.2 296.6 481.2 287.5 496.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.5 383.5l6.4-3.7c-9.3-16.1-22.3-29.9-37.8-40.2l-4.1 6.1C266.2 355.1 278.4 367.8 287.5 383.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.3 329l1.4-7.2c-4.4-.9-8.9-1.5-13.4-1.9l-.6 7.3C202.9 327.6 207.1 328.2 211.3 329z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.1 341l3.6-6.5c-8-4.4-16.5-7.9-25.4-10.5l-2 7.1C228.5 333.5 236.5 336.8 244.1 341z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage05Layer3);
export default __webpack_public_path__ + "static/media/image-05-layer-3.d6d536d2e614a792703c78ce7ab93c98.svg";
export { ForwardRef as ReactComponent };